import React, {useEffect, useState, useCallback} from "react";
import Required from "../../../../components/Required";
import Checkbox from "../../../../components/Checkbox";
import { DisabledCheckbox } from '../../orgs/7042/components'
import {FacilityItem} from '../../sections/AuthorizationToReleaseSection'
import './FacilitiesSection.scss'

const CarbonFacilitySection = ({ formik, inputClasses, props, template, config, preCheckedFacility }) => {

    
    const [facilitiesGroup, setFacilitiesGroup] = useState()
    const [facilitiesArray, setFacilitiesArray] = useState()

    
    
    
    useEffect(()=>{
      // When local facilitiesGroup changes, update formik facilitiesGroup

      console.log(formik.values.facilitiesGroup)
      const emptyFacilitiesGroup = facilitiesGroup && Object.values(facilitiesGroup).every((value)=>{ return !value })
      
      if (emptyFacilitiesGroup) {
        formik.setFieldValue('facilitiesGroup', [])
      }
      else {
        formik.setFieldValue('facilitiesGroup', [facilitiesGroup])
        console.log(facilitiesGroup)
      }
      console.log(formik.values.facilitiesGroup)
      
    }, [facilitiesGroup])

    useEffect(()=>{
      console.log(formik.values.facilitiesGroup)
    }, [formik.values.facilitiesGroup])

    
    
    useEffect(()=>{
      console.log(formik.values.facilitySelected)
      if (formik.values.facilitiesGroup[0]) {
          (!formik.values.facilitiesGroup[0].customFacName1 || !formik.values.facilitiesGroup[0].customFacAddress1) ? formik.setFieldValue('facilitySelected', "") : formik.setFieldValue('facilitySelected', true)
      }
    }, [formik.values.facilitiesGroup])

    
    
    
    const updateFacilities = (e, firstIndex, secondIndex) => {
        setFacilitiesGroup(facilitiesGroup.map((innerArray, index)=>{
            console.log(index)
            
            if (index === firstIndex) {
                innerArray.map((info, index)=>{
                    if (index === secondIndex) {
                        return innerArray
                    }
                })
                
                return [e.target.value, innerArray[1]]
            }
            
            else {
                return innerArray
            }
      })); 
        console.log(facilitiesGroup)}
    
    return (
        config.page.form.sections.authorizationToReleaseSection.active ?
          <div id='medicalFacilitiesRequested' className='form-section carbon-health-facilities'>
            <h2 style={template.styles.section} className="section-heading"> {template.title} </h2>
            {preCheckedFacility &&
              <label className='non-textbox-label'> 
                <span style={template.styles.label}> {'Specify the facilities you authorize to release medical information'} </span> {" "} 
                {/* <Required value={template.fields.facilitiesGroup.validations.required.value} />  */}
              </label>
            }
    
              {preCheckedFacility &&
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" checked={true} className='checkbox' id='defaultCheck'/> <label htmlFor="defaultCheck" style={{fontWeight: 400}}>{template.fields.facilitiesGroup.entries[0].value}</label>
                </div>
              }
            <div id='ordinary-facilities' className='form-fields' style={{flexFlow: 'column', maxHeight:250, marginBottom: 10, marginTop: 20}}>

              <label htmlFor="" style={{marginBottom: 10}}>List clinics and providers below (You must enter information into the first name and address boxes, respectively) <Required value={template.fields.facilitiesGroup.validations.required.value} /> </label>
              <div className='name-address-facility-input-container-holder'>
                  <FacilitySet setIndex={1} facilitiesGroup={facilitiesGroup} setFacilitiesGroup={setFacilitiesGroup} formik={formik}/>
                  <FacilitySet setIndex={2} facilitiesGroup={facilitiesGroup} setFacilitiesGroup={setFacilitiesGroup} formik={formik}/>
                  <FacilitySet setIndex={3} facilitiesGroup={facilitiesGroup} setFacilitiesGroup={setFacilitiesGroup} formik={formik}/>
                  <FacilitySet setIndex={4} facilitiesGroup={facilitiesGroup} setFacilitiesGroup={setFacilitiesGroup} formik={formik}/>
              </div>
            </div>
          </div>
          :
          <></>
      );
};

export default CarbonFacilitySection;

const FacilitySet = ({setIndex, facilitiesGroup, setFacilitiesGroup, formik}) => {
  
  
  return (
        <div style={{display:'flex'}} className='name-address-facility-input-container'>
            <input type="text" className='form-control name-address-facility-input name-input' placeholder={"Facility Name"} onChange={(e)=>{
                setFacilitiesGroup(
                  // {...facilitiesGroup, [setIndex]: [e.target.value, facilitiesGroup[setIndex][1]]}
                    {...facilitiesGroup, [`customFacName${setIndex}`]: e.target.value}
                );
                
              }}
            />
            <input type="text" className='form-control name-address-facility-input address-input' placeholder={"Facility Address"} onChange={(e)=>{
              setFacilitiesGroup(
                
                {...facilitiesGroup, [`customFacAddress${setIndex}`]: e.target.value}
                
                ); 
              }}
            /> 
            <input type="text" className='form-control name-address-facility-input doctor-input' placeholder={"Name of Doctor (Optional)"} onChange={(e)=>{
              setFacilitiesGroup(
                
                {...facilitiesGroup, [`customFacDoctor${setIndex}`]: e.target.value}
                
                ); 
              }}
            /> 
          </div>
    )
}